import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
// Removed Footer import, likely handled by layout
import { useEffect } from "react";

const FreddyCyklar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar with white background */}
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-sm">
        <Navbar />
      </div>
      
      <main className="flex-grow"> {/* Removed pt-[72px] */}
        {/* Hero Section */}
        <section className="relative h-screen flex items-center justify-center">
          <div className="absolute inset-0">
            <img
              src="/images/kampanjer/freddy-cyklar-ai.webp"
              alt="Freddy på cykel"
              className="w-full h-full object-cover brightness-50"
            />
          </div>
          <div className="relative container mx-auto px-4 text-center text-white pt-[88px]"> {/* Added pt-[88px] */}
            <blockquote className="max-w-4xl mx-auto">
              <p className="text-4xl md:text-6xl font-bold mb-8">
                "Det gäller att ta vara på livet och hälsan, därför ska jag genomföra En Svensk Klassiker."
              </p>
              <footer className="text-2xl md:text-3xl">
                – Freddy Sjöstrand, diagnos Alzheimer 54 år ung
              </footer>
            </blockquote>
          </div>
        </section>

        {/* Om Freddy Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <img
                  src="/images/kampanjer/23-Caroline-Freddy-01.jpg"
                  alt="Freddy Sjöstrand"
                  className="w-full aspect-square object-cover rounded-2xl shadow-xl"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Livet vändes upp och ner</h2>
                <div className="space-y-4 text-gray-700">
                  <p>
                    Livet förändrades drastiskt för Fredrik "Freddy" Sjöstrand när han vid 54 års ålder fick diagnosen Alzheimers sjukdom. Mitt i livet, med familj och karriär, tvingades han möta en framtid fylld av osäkerhet.
                  </p>
                  <p>
                    Men istället för att ge upp bestämde sig Freddy för att inspirera andra – och nu tar han sig an en av Sveriges största cykelutmaningar: Vätternrundan 2025.
                  </p>
                  <p>
                    Nu trampar Freddy inte bara för sin egen skull. Han cyklar för alla som lever med demens, för att visa att livet inte tar slut med en diagnos.
                  </p>
                  <p>
                    Freddy bevisar att diagnosen inte definierar honom – hans vilja att kämpa gör det.
                  </p>
                  <p>
                    Nu trampar vi tillsammans mot bättra hälsa längre och en ljusare framtid. 🚴‍♂️💙
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Fysisk aktivitet och demens Section */}
        <section className="py-24 bg-[#F8F2FF]">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Rörelse gör skillnad</h2>
                <blockquote className="space-y-4 text-gray-700">
                  <p>
                    "FINGER-studien av Miia Kivipelto är den första storskaliga studien som visar på att enkla livsstilsförändringar, så som fysisk aktivitet som cykling, kan förebygga försämring hos personer som är i riskzonen för demens.
                  </p>
                  <p>
                    Deltagarna i forskningsstudien visade på 40% förbättrat minne."
                  </p>
                </blockquote>
                <Link 
                  to="https://www.minnestig.se/kunskapsbanken/finger-studien-av-miia-kivipelto/"
                  className="inline-block mt-6 text-minnestig-purple hover:text-minnestig-teal font-medium"
                >
                  Läs mer om studien →
                </Link>
              </div>
              <div>
                <img
                  src="/images/kampanjer/ai-gen-freddy-cyklar-rorelse.webp"
                  alt="Fysisk aktivitet och demens"
                  className="w-full h-auto rounded-2xl shadow-xl"
                />
              </div>
            </div>

            {/* Statistik Section */}
            <div className="mt-24">
              <h2 className="text-3xl font-bold text-gray-900 mb-16 text-center">Livsstilsförändringarnas resultat</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div className="text-center">
                  <p className="text-5xl md:text-6xl font-bold text-minnestig-purple mb-4">40%</p>
                  <p className="text-gray-700">Förbättrat minne</p>
                </div>
                <div className="text-center">
                  <p className="text-5xl md:text-6xl font-bold text-minnestig-purple mb-4">83%</p>
                  <p className="text-gray-700">Förbättrad exekutiv funktion (kunna ta beslut)</p>
                </div>
                <div className="text-center">
                  <p className="text-5xl md:text-6xl font-bold text-minnestig-purple mb-4">25%</p>
                  <p className="text-gray-700">Förbättrad förmåga att hantera komplexa minnesuppgifter</p>
                </div>
                <div className="text-center">
                  <p className="text-5xl md:text-6xl font-bold text-minnestig-purple mb-4">150%</p>
                  <p className="text-gray-700">Snabbare förmåga att bearbeta och svara på information</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Insamling Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className="text-center md:text-left">
                <div className="mb-8">
                  <img
                    src="/images/logos/alzheimerfonden_logo.png"
                    alt="Alzheimerfonden"
                    className="h-16 md:h-20 w-auto mx-auto md:mx-0"
                  />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Var med och bidra till forskningen</h2>
                <div className="space-y-6">
                  <p className="text-gray-700 text-lg">
                    Det kunde varit DU – hjälp oss att minska stigmat kring demenssjukdom och stöd forskarnas arbete framåt 💜
                  </p>
                  <p className="text-gray-700 text-lg">
                    Allt fler personer i arbetsför ålder insjuknar i Alzheimers sjukdom.
                  </p>
                  <p className="text-gray-700 text-lg">
                    Freddy cyklar också för att samla in pengar till Alzheimerfonden.
                  </p>
                  <p className="text-gray-700 text-lg">
                    Alla som skänker 100 kr eller mer deltar i utlottningen av tavlan målad av @Madebyelsaa (värde 2 500 SEK).
                  </p>
                  <a 
                    href="https://insamling.alzheimerfonden.se/fundraisers/freddy-cyklar-vatternrundan"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-minnestig-purple hover:bg-minnestig-teal text-white py-4 px-8 rounded-full font-medium transition-colors"
                  >
                    Stöd insamlingen →
                  </a>
                </div>
              </div>
              <div className="flex justify-center">
                <img
                  src="/images/kampanjer/kampanj-freddy-cyklar-tavla.jpg"
                  alt="Tavlan Pingvinen"
                  className="w-[60%] rounded-2xl shadow-xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Freddys sponsorer Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Freddys sponsorer</h2>
            
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {/* Sponsor 1 */}
              <div className="p-6 rounded-2xl flex flex-col items-center justify-center">
                <a 
                  href="https://www.demenshjaltar.se" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mb-4 hover:opacity-80 transition-opacity"
                >
                  <img
                    src="/images/logos/demenshjaltar-logo-dark-utan-tagline.png"
                    alt="Demenshjältar"
                    className="h-16 w-auto object-contain"
                  />
                </a>
                <p className="text-center text-sm text-gray-600">Kampanjvärd</p>
              </div>

              {/* Sponsor 2 */}
              <div className="p-6 rounded-2xl flex flex-col items-center justify-center">
                <a 
                  href="https://madebyelsaa.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mb-4 hover:opacity-80 transition-opacity"
                >
                  <img
                    src="/images/kampanjer/freddy-cyklar-11.webp"
                    alt="Sponsor logo"
                    className="h-16 w-auto object-contain"
                  />
                </a>
                <p className="text-center text-sm text-gray-600">Tavlan till insamlingen för Alzheimerfonden</p>
              </div>

              {/* Sponsor 3 */}
              <div className="p-6 rounded-2xl flex flex-col items-center justify-center">
                <a 
                  href="https://www.bjoornscykel.se/category/racercyklar" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mb-4 hover:opacity-80 transition-opacity"
                >
                  <img
                    src="/images/kampanjer/freddy-cyklar-10.webp"
                    alt="Sponsor logo"
                    className="h-16 w-auto object-contain"
                  />
                </a>
                <p className="text-center text-sm text-gray-600">Cyklen från Scott</p>
              </div>

              {/* Placeholder Sponsor 4 */}
              <div className="p-6 rounded-2xl flex flex-col items-center justify-center">
                <Link 
                  to="/kampanjer/freddy-cyklar/bli-sponsor"
                  className="mb-4 hover:opacity-80 transition-opacity w-full"
                >
                  <div className="h-16 w-full bg-gray-100 rounded flex items-center justify-center">
                    <span className="text-gray-400">Din logo här</span>
                  </div>
                </Link>
                <p className="text-center text-sm text-gray-600">Sponsra med anmälningsavgiften</p>
              </div>

              {/* Placeholder Sponsor 5 */}
              <div className="p-6 rounded-2xl flex flex-col items-center justify-center">
                <Link 
                  to="/kampanjer/freddy-cyklar/bli-sponsor"
                  className="mb-4 hover:opacity-80 transition-opacity w-full"
                >
                  <div className="h-16 w-full bg-gray-100 rounded flex items-center justify-center">
                    <span className="text-gray-400">Din logo här</span>
                  </div>
                </Link>
                <p className="text-center text-sm text-gray-600">Sponsra med resa och boende till loppet</p>
              </div>
            </div>

            <div className="text-center mt-12">
              <Link 
                to="/kampanjer/freddy-cyklar/bli-sponsor"
                className="inline-block bg-minnestig-purple hover:bg-minnestig-teal text-white py-4 px-8 rounded-full font-medium transition-colors"
              >
                Bli sponsor →
              </Link>
            </div>
          </div>
        </section>

        {/* Följ Freddys träning Section */}
        <section className="py-24 bg-[#F8F2FF]">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Följ Freddys träning</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Box 1 */}
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="aspect-square relative">
                  <img
                    src="/images/kampanjer/freddy-cyklar-07.jpg"
                    alt="Freddy tränar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-gray-700 mb-4">
                    "Idag blev det ett härligt träningspass på 8,5 mil på 3 timmar. Känner mig stark och redo för nästa utmaning! 💪"
                  </p>
                  <p className="text-sm text-gray-500">April 2025</p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="aspect-square relative">
                  <img
                    src="/images/kampanjer/freddy-cyklar-09.jpg"
                    alt="Freddy på cykel"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-gray-700 mb-4">
                    "Morgonpass på 6 mil. Cykla du också, det är kul! Tillsammans är vi starka! 🚴‍♂️"
                  </p>
                  <p className="text-sm text-gray-500">April 2025</p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="aspect-square relative">
                  <img
                    src="/images/kampanjer/freddy-cyklar-06.jpg"
                    alt="Freddy stretchar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-gray-700 mb-4">
                    "Tillbaka från 2 veckor i Thailand, nu är jag redo att kicka igång träningen på allvar🌟"
                  </p>
                  <p className="text-sm text-gray-500">Mars 2025</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Följ Freddy live och Media Section */}
        <section className="py-24 bg-[#F8F2FF]">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Följ Freddy live */}
              <div>
                <div className="text-center md:text-left">
                  <h2 className="text-3xl font-bold text-gray-900 mb-8">Följ Freddy live</h2>
                  <div className="space-y-6">
                    <p className="text-gray-700 text-lg">
                      Freddy startar Vätternrundan lördagen den 14 juni kl. 05.22.
                    </p>
                    <p className="text-gray-700 text-lg">
                      Vi kommer länka till liveuppdateringar från loppet på denna sida.
                    </p>
                    <button className="bg-gray-400 text-white py-4 px-8 rounded-full font-medium cursor-not-allowed">
                      Kommer snart
                    </button>
                  </div>
                </div>
              </div>

              {/* Freddy i media */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center md:text-left">Freddy cyklar – i media</h2>
                <div className="space-y-6">
                  <a 
                    href="https://cykla.se/artiklar/fredrik-54-drabbades-av-alzheimers-nu-ska-han-cykla-vatternrundan/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-2xl">📰</span>
                      <span className="text-gray-900 font-medium">Artikel i cykla.se →</span>
                    </div>
                  </a>
                  <a 
                    href="https://www.sverigesradio.se/artikel/fredrik-drabbades-av-alzheimer-nu-ska-han-cykla-vatternrundan"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-2xl">🎧</span>
                      <span className="text-gray-900 font-medium">Freddy i P4 Sörmland →</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Removed Footer instance, likely handled by layout */}
    </div>
  );
};

export default FreddyCyklar;
